import {createAction} from '@ngrx/store';

export const doctorHasBeenConnected = createAction('[Call Component] DoctorHasBeenConnected');
export const patientHasBeenConnected = createAction('[Call Component] PatientHasBeenConnected');
export const initConnection = createAction('[Call Component] InitConnection');